import client from '@/lib/axios-client'
import type {
	CreateSystemBranchBody,
	CreateSystemBranchResponse,
	UpdateBranchCustomNameBody,
	UpdateBranchCustomNameResponse,
	UpdateBranchVisibilityBody,
	UpdateBranchVisibilityResponse,
	UpdateCROverridesBody,
	UpdateCROverridesResponse,
} from '@/types/organization-overrides'

const ORG_URL = '/organization'

// ── POST /organization/branches ───────────────────────────────────────────────

export async function createSystemBranch(
	body: CreateSystemBranchBody,
): Promise<CreateSystemBranchResponse> {
	const response = await client.post(`${ORG_URL}/branches`, body)
	return response.data.data
}

// ── PATCH /organization/branches/:id/customize ────────────────────────────────

export async function updateBranchCustomName(
	id: string,
	body: UpdateBranchCustomNameBody,
): Promise<UpdateBranchCustomNameResponse> {
	const response = await client.patch(
		`${ORG_URL}/branches/${id}/customize`,
		body,
	)
	return response.data.data
}

// ── PATCH /organization/crs/:id/customize ─────────────────────────────────────

export async function updateCROverrides(
	id: string,
	body: UpdateCROverridesBody,
): Promise<UpdateCROverridesResponse> {
	const response = await client.patch(`${ORG_URL}/crs/${id}/customize`, body)
	return response.data.data
}

// ── PATCH /organization/branches/:id/visibility ───────────────────────────────

export async function updateBranchVisibility(
	id: string,
	body: UpdateBranchVisibilityBody,
): Promise<UpdateBranchVisibilityResponse> {
	const response = await client.patch(
		`${ORG_URL}/branches/${id}/visibility`,
		body,
	)
	return response.data.data
}

// ── DELETE /organization/branches/:id ────────────────────────────────────────

export async function deleteSystemBranch(id: string): Promise<void> {
	await client.delete(`${ORG_URL}/branches/${id}`)
}
